import { SafePromise } from '@benzinga/safe-await';
import { ExtendedSubscribable } from '@benzinga/subscribable';

import { Session } from '@benzinga/session';
import { ConnatixLiveStreamResponse } from './entities';
import { LivestreamRequest, LivestreamRequestEvent } from './request';
import { LivestreamStore } from './store';

interface LivestreamFunctions {
  getConnatixLivestream: LivestreamManager['getConnatixLivestream'];
}

export type LivestreamManagerEvent = LivestreamRequestEvent;

export class LivestreamManager extends ExtendedSubscribable<LivestreamManagerEvent, LivestreamFunctions> {
  private request: LivestreamRequest;
  private store: LivestreamStore;

  constructor(session: Session) {
    super();
    this.request = new LivestreamRequest(session);
    this.store = new LivestreamStore();
  }

  public static getName = () => 'benzinga-livestream';

  public getStoredConnatixLivestream = () => {
    return this.store.getLivestreamData('connatix');
  };

  public getConnatixLivestream = async (force?: boolean): SafePromise<ConnatixLiveStreamResponse | undefined> => {
    if (force || this.store.shouldFetchStreamDataSettings('connatix')) {
      const resp = await this.request.getConnatixLivestream();

      if (resp.err) {
        return { ok: undefined };
      }

      if (resp.ok) {
        this.store.setLivestreamData('connatix', resp.ok);

        return resp;
      } else {
        return { ok: undefined };
      }
    } else {
      return {
        ok: this.store.getLivestreamData('connatix'),
      };
    }
  };

  protected onSubscribe(): LivestreamFunctions {
    return {
      getConnatixLivestream: this.getConnatixLivestream,
    };
  }
}
